import React from 'react'

import './tagsArticles.scss'

const TagsArticles = props => {
    return (
        <div className="f-tags">
            {props.tags && props.tags.map((tag, index) => {
              let className = "f-tags-tag "
              switch (tag.categoria[0].slug) {
                    case "mujeres":
                        className += "f-tags-tag-pink"
                        break;
                    case "hombres":
                        className += "f-tags-tag-orange"
                        break;
                    case "cuidadores":
                        className += "f-tags-tag-green"
                        break;

                    default:
                        break;
                }
                if (props.tagActive[index]) className += " f-tags-tag-active"
                return <div className={className} key={index}
                    onClick={() => {
                        if (props.tagActive[index] !== undefined) {
                            props.tagActive[index] = undefined
                        } else {
                            props.tagActive[index] = tag.nombreDeEtiqueta
                        }
                        const arr = props.tagActive
                        props.setTagActive([...arr])
                        props.filterTag()
                    }
                    }>
                    <p>{tag.nombreDeEtiqueta}</p>
                </div>
            })}
            <div className={`f-tags-tag f-tags-tag-bienestar`} onClick={ () => {
                props.tags && props.tags.map((tag, index) =>{
                    return props.tagActive[index] = undefined
                });
                const arr = props.tagActive
                props.setTagActive([...arr])
                props.filterTag()
            }
            }><p>LIMPIAR FILTROS</p></div>
        </div >
    )
}

export default TagsArticles
